var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgNoteOutline = function SvgNoteOutline(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 19H13V18.5V13L13 12H14H19.5H20V6C20 5.4588 19.5543 5.01 19 5.01H18.9992L6 5C5.99981 5 5.99962 5 5.99943 5C5.44545 5.00031 5 5.44898 5 5.99L5 18C5 18.5477 5.45228 19 6 19Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 13L14 18V20H15L21 14V13H19Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNoteOutline);
export { ForwardRef as ReactComponent };